/* RESPONSIBLE TEAM: team-workflows */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'operator_settings/upfront_collection';
  },
});
